import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Alert,
  CircularProgress,
} from '@mui/material';
import { auth } from '../../services/api';

interface ResendVerificationProps {
  email?: string;
  onSuccess?: () => void;
}

const ResendVerification: React.FC<ResendVerificationProps> = ({
  email: initialEmail,
  onSuccess,
}) => {
  const [email, setEmail] = useState(initialEmail || '');
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus('idle');

    try {
      const response = await auth.resendVerification(email);
      setStatus('success');
      setMessage(response.message);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error: any) {
      setStatus('error');
      setMessage(error.message || 'Failed to send verification email');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
      {!initialEmail && (
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isLoading}
          size="small"
        />
      )}

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: initialEmail ? 0 : 2 }}
          disabled={!email || isLoading}
          size="small"
        >
          Resend Verification Email
        </Button>
      )}

      {status === 'success' && (
        <Alert severity="success" sx={{ mt: 2 }}>
          {message}
        </Alert>
      )}

      {status === 'error' && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {message}
        </Alert>
      )}
    </Box>
  );
};

export default ResendVerification; 